module.exports = __webpack_public_path__ + "static/0029-f68a079379ab239848c399f4f16b830f.png";